import { VCombobox } from 'vuetify/lib/components/VCombobox';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCombobox,{attrs:{"value":_vm.initialValue,"disabled":_vm.disabled,"items":_vm.engines,"label":_vm.label,"dense":"","filled":"","item-disabled":"in_use_set","item-text":"name","item-value":"name"},on:{"change":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }